<link
  href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp"
  rel="stylesheet">
  <mat-toolbar class="fixed-header" color="accent">
    <mat-toolbar-row>
      <span class="logo-and-title">
        <a href="/">
          <img class="logo" src="../../../assets/kronopol-logo.png" alt="Swiss Krono">
        </a>
        @if (bookType !== 'KBW') {
          <span>
            <h4>{{title}}</h4>
          </span>
        } @else {
          <h4>{{'KbwTitle' | translate }}</h4>
        }
      </span>
      @if (logoutBtn) {
        <div class="logout" (click)="onLogout()">
          <button mat-stroked-button>{{'logout' | translate}}</button>
        </div>
      }
      @if (!isHiddenMenu) {
        <span class="menu-spacer"></span>
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #menu="matMenu" class="right-menu">
          <!-- <button mat-menu-item disabled>
          <mat-icon>face</mat-icon>
          <span>Zaloguj się</span>
        </button> -->
        <button mat-menu-item (click)="onClearExam()">
          <mat-icon>clear</mat-icon>
          <span>{{'CleanExam' | translate }}</span>
        </button>
        <button mat-menu-item>
          <mat-icon>arrow_back</mat-icon>
          <a [routerLink]="['/']"><span>{{'Back' | translate }}</span></a>
        </button>
      </mat-menu>
    }
  </mat-toolbar-row>
  @if (isProgressNeeded) {
    <mat-toolbar-row class="progress-row">
      <!-- <span style="font-size: 12px;">Nazwa egzaminu: {{examCode}}</span> -->
      <mat-progress-bar class="exam-progress-bar" color="warn" mode="determinate"
      value="{{progressValue}}"></mat-progress-bar>
    </mat-toolbar-row>
  }
</mat-toolbar>